/* eslint-disable */
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { isDealer } from '../utils';

const useDealer = () => {
  const navigate = useNavigate();
  const params = useParams();

  const location = useLocation();
  let path = location.pathname.split('/');

  let dealerName;
  let parentPath;
  let dreamKitchen;

  if (params.dealer) {
    if (isDealer(params.dealer)) {
      parentPath = path[2];
      dreamKitchen = path[3] === 'dream-kitchen';
      dealerName = path.splice(1, 1)[0];
    } else {
      navigate(`/${dealerName}/404`);
    }
  } else {
    parentPath = path[1];
    dreamKitchen = path[2] === 'dream-kitchen';
  }

  return {
    parentPath,
    dreamKitchen,
    dealerName,
  };
};

export default useDealer;
